module.exports = __webpack_public_path__ + "img/not-found.5e9d45b9.png";